import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js'

// 正式发布版本：禁用所有 console 输出
// 这将禁用 console.log, console.warn, console.error, console.debug, console.info
// 用于 public-version 分支的生产环境
console.log = () => {};
console.warn = () => {};
console.error = () => {};
console.debug = () => {};
console.info = () => {};

// 确保Bootstrap全局可用
window.bootstrap = bootstrap;

createApp(App).mount('#app') 